<template>
    <div class="question-list-container">
        <h4>样品申请对话列表</h4>
        <router-link v-for="item in list"
                     :to="{name:'questionDetailFromSample',params:{ticketNumber:item.ticketNumber,projectId}}"
                     :key="item.id">
            <van-cell-group class="panel">
                <van-cell title="订单号"
                          :value="item.ticketNumber"></van-cell>
                <van-cell title="申请时间"
                          :value="item.createdAt"></van-cell>
                <van-cell title="审核状态">
                    <van-tag :color="COLOR[item.status.remark]">{{ item.status.remark }}</van-tag>
                </van-cell>
                <van-cell title="状态流转备注"
                          :value="item.status.content"
                          v-if="item.status.content"></van-cell>
                <van-cell v-for="row in item.parameters.filter((_) => /address|select/i.test(_.name+_.type))"
                          :title="row.title"
                          :value="row.label"
                          :key="row.name"></van-cell>
            </van-cell-group>
            <van-empty description="暂无内容"
                       v-if="!list.length"></van-empty>
        </router-link>
    </div>
</template>

<script>
import { COLOR } from './statusConfig'
import { GetAuditList, GetSubmitList } from '@custouch/proxy-use'
import { mapActions } from 'vuex'
import { FORM_CHAT_FLAG } from '@/configs/constants'
import dayjs from 'dayjs'
export default {
    data() {
        return {
            projectId: window.env.VUE_APP_TICKET_SAMPLE_ID,
            COLOR,
            list: []
        }
    },
    methods: {
        ...mapActions(['getRole']),
        async init() {
            let getList = GetSubmitList
            const {staffId} = await this.getRole(this.projectId)
            if (staffId) {
                getList = GetAuditList
            }
            const { data } = await getList({ projectId: this.projectId, index: 1, size: 999, staffId })
            this.list = data.reduce((pre, cur) => {
                if (cur.parameters.find(item => item.name === FORM_CHAT_FLAG)?.value) {
                    cur.createdAt = dayjs(cur.createdAt).format('YYYY/MM/DD HH:mm')
                    pre.push(cur)
                }
                return pre
            }, [])
        }
    },
    created() {
        this.init()
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/var';
.question-list-container {
    padding: 0 1rem;
}
.panel {
    border: 1px solid @gray-3;
    box-shadow: 0 0 2px @gray-3;
    margin-bottom: 1rem;
}
</style>